// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 443 ? "about" : chunkId) + "-legacy." + {"119":"50d2032d","155":"5561e1e9","197":"e820e8f1","346":"6052d198","443":"161a0d18","787":"c3d9ed64"}[chunkId] + ".js";
};